import { render, staticRenderFns } from "./SectionListings.vue?vue&type=template&id=34faf166&"
import script from "./SectionListings.vue?vue&type=script&lang=js&"
export * from "./SectionListings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports